(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/oddset-kambi/components/seo-articles/assets/javascripts/utils.js') >= 0) return;  svs.modules.push('/modules/oddset-kambi/components/seo-articles/assets/javascripts/utils.js');
"use strict";


const getSeoArticles = function (cmsArticles) {
  let currentPath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  const articles = cmsArticles.filter(item => {
    var _item$article;
    if (!((_item$article = item.article) !== null && _item$article !== void 0 && _item$article.body)) {
      return false;
    }
    if (item.isLandingpage) {
      return currentPath === '/odds' || currentPath === '/odds/';
    }
    return currentPath.includes(item.filter);
  }).sort((a, b) => a.order - b.order);
  return articles;
};
if (svs.isServer) {
  module.exports = {
    getSeoArticles
  };
} else {
  setGlobal('svs.oddset_kambi.components.seo_articles.getSeoArticles', {
    getSeoArticles
  });
}

 })(window);